export const GROUP_VIEW_PARAM = "groupView";

export const GROUP_VIEW_FILTER_PARAMS = {
  warehouseId: "groupViewWarehouseId",
  inventory: "groupViewInventory",
  costCenterId: "groupViewCostCenterId",
};
